import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactPlayer from 'react-player';
import getClosest from '../../utils/getClosest';
import { Waypoint } from 'react-waypoint';
import { component } from 'picoapp';

const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

class MediaPlayer extends Component {
  constructor(el, ctx) {
    super();
    this.state = { mediaUrl: '', playing: false, autoPlay: false };
    this.start = this.start.bind(this);
    this.pause = this.pause.bind(this);
  }

  componentDidMount() {
    const { parentNode } = this.props;
    this.setState({
      mediaUrl: parentNode.dataset.videoUrl,
      autoPlay: parentNode.dataset.autoPlay
    });
    this.parentController = getClosest(ReactDOM.findDOMNode(this), '.js-videoController');
    if (this.parentController) {
      this.parentController.addEventListener('isActive', this.start.bind(this));
      this.parentController.addEventListener('isInactive', this.pause.bind(this));
    }
  }

  start() {
    this.setState({ playing: true });
  }

  pause() {
    this.setState({ playing: false });
  }

  render() {
    const { autoPlay } = this.state;
    return (
      <ConditionalWrapper
        condition={autoPlay}
        wrapper={(children) => (
          <Waypoint
            scrollableAncestor={window}
            onEnter={({ previousPosition, currentPosition }) => {
              this.setState({ playing: true });
            }}
            onLeave={() => {
              this.setState({ playing: false });
            }}
          >
            {children}
          </Waypoint>
        )}
      >
        <div>
          <ReactPlayer
            className="media-player"
            url={this.state.mediaUrl}
            playing={this.state.playing}
            width="100%"
            height="100%"
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  showinfo: 0
                }
              },
              vimeo: {
                playerOptions: {
                  responsive: true
                }
              }
            }}
          />
        </div>
      </ConditionalWrapper>
    );
  }
}

export default component((node, ctx) => {
  const element = <MediaPlayer appstate={ctx} parentNode={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function() {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
